import React, { memo } from 'react';
import { TableCell } from './TableCell';
import { _single } from '../../../core/services/dataBean/EntityCatalog';

interface Props {
    bean: any;
    index: number;
    isSelected: boolean;
    isMenuOpen: boolean;
    titulo: any[];
    listButtons: any;
    onRowClick: (bean: any, index: number) => void;
    onMenuClick: (event: React.MouseEvent<HTMLElement>, index: number) => void;
    onCellClick: (value: any) => void;
    callBack?: any;
}

export const TableRow = memo(({
    bean,
    index,
    isSelected,
    isMenuOpen,
    titulo,
    listButtons,
    onRowClick,
    onMenuClick,
    onCellClick,
    callBack
}: Props) => {
    return (
        <tr
            className={`cursor ${isSelected ? "table-primary text-primary" : ""}`}
            onClick={() => {
                onRowClick(bean, index);
                // _single.printOut(bean.DataBeanProperties); // Moved to parent or keep here? Keeping side effect in parent is better but for now let's follow existing pattern or just call the handler.
                // The original code called _single.printOut here. I'll let the parent handle it to keep this pure, 
                // BUT the parent handler being passed `onRowClick` can do it.
            }}
        >
            {listButtons &&
                <td className='border-end-dashed'>
                    <div className="position-relative">
                        <i
                            className={isMenuOpen ? 'ri-close-line m2 iconmenu' : 'ri-more-2-line iconmenu m2'}
                            onClick={(e) => {
                                // e.stopPropagation(); // Important to prevent row click
                                onMenuClick(e, index);
                            }}
                        />
                    </div>
                </td>
            }
            {titulo.map((item: any, colIndex: number) => {
                return item.visible && (
                    <td key={colIndex} onClick={() => {
                        if (item.cellEditor) {
                            onRowClick(bean, index);
                        }
                    }}>
                        <TableCell
                            head={item}
                            cell={bean.DataBeanProperties}
                            returnValue={onCellClick}
                            callBack={callBack}
                        />
                    </td>
                );
            })}
        </tr>
    );
}); // Comparison function can be added if needed, but simple memo should work if props are stable
